<template>
  <div class="card-form">
    <page-main
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      @reload="reload"
      @openEditPage="openEditPage"
      @uploadReceipt="uploadReceipt"
    >
      <page-header
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
        @openEditPage="openEditPage"
      />
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </page-main>

    <UploadReceipt
      :title="'上传回单'"
      :visible.sync="uploadReceiptOptions.visible"
      :shipmentExpenseCode="uploadReceiptOptions.code"
    />
  </div>
</template>
<script>
import PageHeader from './header'
import PageMain from './main.vue'
import BaseTable from '@/mixins/base-table'
import UploadReceipt from '../upload-receipt'
export default {
  mixins: [BaseTable],
  components: { PageMain, PageHeader, UploadReceipt },
  data() {
    return { usePage: true, uploadReceiptOptions: { visible: false, code: '' } }
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .shipmentExpenseListApi({
          ...form,
          ...this.page,
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    openEditPage({ pageType, params = {}, query = {} }) {
      this.$router.push({
        name: 'transport-shipmentExpense-detail',
        params: { ...params, pageType },
        query,
      })
    },
    uploadReceipt({ shipmentExpenseCode: code }) {
      this.uploadReceiptOptions = { visible: true, code }
    },
  },
}
</script>
